import {
  createSlice,
  createAsyncThunk,
} from '@reduxjs/toolkit'

const initialState = {
  profileData: {
    status: "idle",
    data: {},
    error: {},
  },
}

export const fetchProfile = createAsyncThunk('profile', async (data) => {
  const {token} = data
  const axios = require("axios")
  const headers = {
                 "Authorization" : `Bearer ${token}`,
                 "Access-Control-Allow-Origin" : "*",
                 "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
              }
      const url = `/api/v0/data/profile/YILI`
       const response = await axios.get(url , 
                 { headers })
      return response.data
})

const profileSlice = createSlice({
  name: 'profile',
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [fetchProfile.pending.type]:(state, action) => {
      state.profileData = {
        status: "loading",
        data: {},
        error: {},
      }
    },
    [fetchProfile.fulfilled.type]:(state, action) => {
      state.profileData = {
        status: "idle",
        data: action.payload,
        error: {},
      }
    },
    [fetchProfile.rejected.type]:(state, action) => {
      state.profileData = {
        status: "idle",
        data: {},
        error: "unauthorized",
      }
    },
  }
})

export default profileSlice.reducer
